import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LookupDetail } from 'src/app/core/models/lookup-detail.model';
import { LookupService } from 'src/app/core/services/lookup.service';


@Injectable({ providedIn: 'root' })
export class LiftErrorLookupResolver implements Resolve<HttpResponse<LookupDetail[]>> {
  constructor(
    private lookupService: LookupService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {

    return this.lookupService.get(new HttpParams(), 'LiftError');
  }
}
